module.exports = __webpack_public_path__ + "869dda33af5a75f772e965ddaf8a0e70.pdf";